import React, { useContext, useEffect, useState } from "react";
import { Col, Form, message, Select, Row } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import OtpInput from "react-otp-input";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { AuthContext } from "./AuthContext";
import { sendOTP, verifyOTP } from "../../utils/API";
import logo from "../../assets/frontendassets/Logos/final net4surge logo.jpg";
import { detectCountryCode } from "../../utils/setting";
import countryData from "./country.json"

const countryMobileLengths: { [key: string]: number } = {
  AD: 6,  // Andorra
  AE: 9,  // United Arab Emirates
  AF: 9,  // Afghanistan
  AG: 10, // Antigua and Barbuda
  AI: 10, // Anguilla
  AL: 9,  // Albania
  AM: 8,  // Armenia
  AO: 9,  // Angola
  AR: 10, // Argentina
  AS: 10, // American Samoa
  AT: 10, // Austria
  AU: 9,  // Australia
  AW: 7,  // Aruba
  AX: 10, // Åland Islands
  AZ: 9,  // Azerbaijan
  BA: 8,  // Bosnia and Herzegovina
  BB: 10, // Barbados
  BD: 10, // Bangladesh
  BE: 9,  // Belgium
  BF: 8,  // Burkina Faso
  BG: 8,  // Bulgaria
  BH: 8,  // Bahrain
  BI: 8,  // Burundi
  BJ: 8,  // Benin
  BL: 6,  // Saint Barthélemy
  BM: 10, // Bermuda
  BN: 7,  // Brunei
  BO: 8,  // Bolivia
  BQ: 7,  // Bonaire
  BR: 11, // Brazil
  BS: 10, // Bahamas
  BT: 8,  // Bhutan
  BW: 8,  // Botswana
  BY: 9,  // Belarus
  BZ: 7,  // Belize
  CA: 10, // Canada
  CC: 6,  // Cocos (Keeling) Islands
  CD: 9,  // Democratic Republic of the Congo
  CF: 8,  // Central African Republic
  CG: 9,  // Republic of the Congo
  CH: 9,  // Switzerland
  CI: 8,  // Côte d'Ivoire
  CK: 5,  // Cook Islands
  CL: 9,  // Chile
  CM: 9,  // Cameroon
  CN: 11, // China
  CO: 10, // Colombia
  CR: 8,  // Costa Rica
  CU: 8,  // Cuba
  CV: 7,  // Cape Verde
  CW: 7,  // Curaçao
  CX: 6,  // Christmas Island
  CY: 8,  // Cyprus
  CZ: 9,  // Czech Republic
  DE: 10, // Germany
  DJ: 8,  // Djibouti
  DK: 8,  // Denmark
  DM: 10, // Dominica
  DO: 10, // Dominican Republic
  DZ: 9,  // Algeria
  EC: 9,  // Ecuador
  EE: 7,  // Estonia
  EG: 10, // Egypt
  EH: 9,  // Western Sahara
  ER: 7,  // Eritrea
  ES: 9,  // Spain
  ET: 9,  // Ethiopia
  FI: 10, // Finland
  FJ: 7,  // Fiji
  FM: 7,  // Micronesia
  FO: 6,  // Faroe Islands
  FR: 9,  // France
  GA: 7,  // Gabon
  GB: 10, // United Kingdom
  GD: 10, // Grenada
  GE: 9,  // Georgia
  GF: 9,  // French Guiana
  GG: 10, // Guernsey
  GH: 9,  // Ghana
  GI: 8,  // Gibraltar
  GL: 6,  // Greenland
  GM: 7,  // Gambia
  GN: 9,  // Guinea
  GP: 9,  // Guadeloupe
  GQ: 9,  // Equatorial Guinea
  GR: 10, // Greece
  GT: 8,  // Guatemala
  GU: 10, // Guam
  GW: 7,  // Guinea-Bissau
  GY: 7,  // Guyana
  HK: 8,  // Hong Kong
  HN: 8,  // Honduras
  HR: 9,  // Croatia
  HT: 8,  // Haiti
  HU: 9,  // Hungary
  ID: 10, // Indonesia
  IE: 9,  // Ireland
  IL: 9,  // Israel
  IM: 10, // Isle of Man
  IN: 10, // India
  IO: 7,  // British Indian Ocean Territory
  IQ: 10, // Iraq
  IR: 10, // Iran
  IS: 7,  // Iceland
  IT: 10, // Italy
  JE: 10, // Jersey
  JM: 10, // Jamaica
  JO: 9,  // Jordan
  JP: 10, // Japan
  KE: 9,  // Kenya
  KG: 9,  // Kyrgyzstan
  KH: 9,  // Cambodia
  KI: 5,  // Kiribati
  KM: 7,  // Comoros
  KN: 10, // Saint Kitts and Nevis
  KP: 10, // North Korea
  KR: 10, // South Korea
  KW: 8,  // Kuwait
  KY: 10, // Cayman Islands
  KZ: 10, // Kazakhstan
  LA: 9,  // Laos
  LB: 7,  // Lebanon
  LC: 10, // Saint Lucia
  LI: 9,  // Liechtenstein
  LK: 7,  // Sri Lanka
  LR: 7,  // Liberia
  LS: 8,  // Lesotho
  LT: 8,  // Lithuania
  LU: 9,  // Luxembourg
  LV: 8,  // Latvia
  LY: 9,  // Libya
  MA: 9,  // Morocco
  MC: 8,  // Monaco
  MD: 8,  // Moldova
  ME: 8,  // Montenegro
  MF: 6,  // Saint Martin
  MG: 9,  // Madagascar
  MH: 7,  // Marshall Islands
  MK: 8,  // North Macedonia
  ML: 8,  // Mali
  MM: 9,  // Myanmar
  MN: 8,  // Mongolia
  MO: 8,  // Macau
  MP: 10, // Northern Mariana Islands
  MR: 8,  // Mauritania
  MS: 10, // Montserrat
  MT: 8,  // Malta
  MU: 8,  // Mauritius
  MV: 7,  // Maldives
  MW: 9,  // Malawi
  MX: 10, // Mexico
  MY: 9,  // Malaysia
  MZ: 9,  // Mozambique
  NA: 8,  // Namibia
  NC: 6,  // New Caledonia
  NE: 8,  // Niger
  NF: 6,  // Norfolk Island
  NG: 10, // Nigeria
  NI: 8,  // Nicaragua
  NL: 9,  // Netherlands
  NO: 8,  // Norway
  NP: 10, // Nepal
  NR: 7,  // Nauru
  NU: 4,  // Niue
  NZ: 9,  // New Zealand
  OM: 8,  // Oman
  PA: 8,  // Panama
  PE: 9,  // Peru
  PF: 6,  // French Polynesia
  PG: 7,  // Papua New Guinea
  PH: 10, // Philippines
  PK: 10, // Pakistan
  PL: 9,  // Poland
  PM: 6,  // Saint Pierre and Miquelon
  PN: 6,  // Pitcairn Islands
  PR: 10, // Puerto Rico
  PT: 9,  // Portugal
  PW: 7,  // Palau
  PY: 9,  // Paraguay
  QA: 8,  // Qatar
  RE: 9,  // Réunion
  RO: 10, // Romania
  RS: 9,  // Serbia
  RU: 10, // Russia
  RW: 9,  // Rwanda
  SA: 9,  // Saudi Arabia
  SB: 7,  // Solomon Islands
  SC: 7,  // Seychelles
  SD: 9,  // Sudan
  SE: 9,  // Sweden
  SG: 8,  // Singapore
  SH: 6,  // Saint Helena
  SI: 8,  // Slovenia
  SK: 9,  // Slovakia
  SL: 8,  // Sierra Leone
  SM: 10, // San Marino
  SN: 9,  // Senegal
  SO: 8,  // Somalia
  SR: 7,  // Suriname
  SS: 9,  // South Sudan
  ST: 7,  // São Tomé and Príncipe
  SV: 8,  // El Salvador
  SX: 7,  // Sint Maarten
  SY: 9,  // Syria
  SZ: 8,  // Eswatini
  TC: 10, // Turks and Caicos Islands
  TD: 8,  // Chad
  TG: 8,  // Togo
  TH: 9,  // Thailand
  TJ: 9,  // Tajikistan
  TK: 4,  // Tokelau
  TL: 7,  // Timor-Leste
  TM: 8,  // Turkmenistan
  TN: 8,  // Tunisia
  TO: 5,  // Tonga
  TR: 10, // Turkey
  TT: 10, // Trinidad and Tobago
  TV: 6,  // Tuvalu
  TW: 10, // Taiwan
  TZ: 9,  // Tanzania
  UA: 9,  // Ukraine
  UG: 9,  // Uganda
  US: 10, // United States
  UY: 8,  // Uruguay
  UZ: 9,  // Uzbekistan
  VA: 10, // Vatican City
  VC: 10, // Saint Vincent and the Grenadines
  VE: 10, // Venezuela
  VG: 10, // British Virgin Islands
  VI: 10, // U.S. Virgin Islands
  VN: 9,  // Vietnam
  VU: 7,  // Vanuatu
  WF: 6,  // Wallis and Futuna
  WS: 7,  // Samoa
  YE: 9,  // Yemen
  YT: 9,  // Mayotte
  ZA: 9,  // South Africa
  ZM: 9,  // Zambia
  ZW: 9   // Zimbabwe
};
  

const Login: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [countryCode, setCountryCode] = useState("IN"); // Default to India
  const [minMobileLength, setMinMobileLength] = useState(10); // Default length
  console.log("countryCode", countryCode);
  const { setAuthData } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchCountryCode = async () => {
      const detectedDialingCode = await detectCountryCode(); // e.g., '+31'
      console.log("detectedDialingCode", detectedDialingCode);
  
      const countryCodeMap: { [key: string]: string } = countryData.reduce((map : any, country : any) => {
        map[country.dialCode] = country.code.toLowerCase();
        return map;
    }, {});
    
      const detectedCountryCode = countryCodeMap[detectedDialingCode] || "in"; // Default to India
      console.log("Detected Country Code:", detectedCountryCode);
  
      setCountryCode(detectedCountryCode);
    };
  
    fetchCountryCode();
  }, []);
  

  const handlePhoneChange = (value: string, country: any) => {
    setMobile(value);
    const selectedCountryCode = country.countryCode.toUpperCase();
    setCountryCode(selectedCountryCode);
    setMinMobileLength(countryMobileLengths[selectedCountryCode] || 9);
  };

  const onFinishStep1 = () => {
    const selectedCountry = countryData.find((c) => c.code === countryCode);
  
    if (!selectedCountry) {
      message.error("Invalid country selection");
      return;
    }
  
    // Extract mobile number without country code dynamically
    const nationalNumber = mobile.startsWith("+")
      ? mobile.substring(selectedCountry.dialCode.length + 1)
      : mobile;
  
    if (!nationalNumber || nationalNumber.length < minMobileLength) {
      message.error(`Please enter a valid mobile number (${minMobileLength} digits required)`  );
      console.log("minMobileLength", nationalNumber);
      return;
    }
  
    setIsLoading(true);
  
    sendOTP({ mobileNo: "+" + mobile })
      .then((res: any) => {
        if (res.status === 201) {
          setStep(2);
          message.success("OTP sent successfully!");
        }
      })
      .catch((error: any) => {
        message.error(error.response?.data?.message || "Failed to send OTP");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  

  const onFinishStep2 = () => {
    setVerifyLoading(true);

    if (!otp) {
      message.error("Please enter OTP");
      setVerifyLoading(false);
      return;
    }

    verifyOTP({ mobile: "+" + mobile, otp })
      .then((res: any) => {
        if (res.status === 200) {
          setAuthData({
            token: res.data.token,
            roleId: res.data.user.roleId,
            user: res.data.user,
          });
          localStorage.setItem("token", res.data.token);

          const redirectPath =
            location.state?.from || (res.data.user.roleId === 1 ? "/backend/dashboard" : "/");
          navigate(redirectPath);
          message.success("Login successful!");
        }
      })
      .catch((error: any) => {
        message.error(error.response?.data?.message || "Invalid OTP");
      })
      .finally(() => {
        setVerifyLoading(false);
      });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <Row align="middle" className="w-full max-w-4xl bg-white shadow-lg rounded-lg overflow-hidden">
        <Col span={12} className="hidden lg:block">
          <img
            src="https://akam.cdn.jdmagicbox.com/images/icontent/hyperlocal/login_banner.svg"
            alt="Login Banner"
            className="object-cover w-full h-full"
          />
        </Col>
        <Col span={24} lg={12} className="p-8">
          <div className="flex justify-center mb-8">
            <Link to="/">
              <img src={logo} alt="Logo" className="h-20" />
            </Link>
          </div>

          {step === 1 ? (
            <Form initialValues={{ remember: true }} onFinish={onFinishStep1} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700">Mobile Number</label>
                <PhoneInput
                  country={countryCode}
                  value={mobile}
                  onChange={handlePhoneChange}
                  enableSearch={true}
                  inputProps={{
                    required: true,
                    name: "mobile",
                    autoFocus: true,
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "48px",
                    paddingLeft: "48px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
                <small className="text-gray-500">Min {minMobileLength} digits required</small>
              </div>
              <Form.Item>
                <button
                  type="submit"
                  className="w-full py-3 px-4 text-white font-semibold rounded-md bg-[#F9B138] hover:bg-[#F9B138] transition"
                  disabled={isLoading}
                >
                  {isLoading ? "Sending OTP..." : "Send OTP"}
                </button>
              </Form.Item>
            </Form>
          ) : (
            <div className="space-y-6">
              <div className="text-center">
                <p className="text-gray-700 text-lg font-semibold">{mobile}</p>
                <button onClick={() => setStep(1)} className="text-blue-500 hover:underline">
                  Edit
                </button>
              </div>
              <Form initialValues={{ remember: true }} onFinish={onFinishStep2} className="space-y-6">
                <div className="text-center">
                  <label className="block text-sm font-medium text-gray-700 pb-3">Enter OTP</label>
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderSeparator={<span className="mx-1" />}
                    renderInput={(props) => <input {...props} className="w-12 h-12 text-center border rounded-md" />}
                    inputStyle={{ width: "100%", padding: "8px" }}
                  />
                </div>
                <Form.Item>
                  <button
                    type="submit"
                    className="w-full py-3 px-4 text-white font-semibold rounded-md bg-[#F9B138] hover:bg-[#F9B138] transition"
                    disabled={verifyLoading}
                  >
                    {verifyLoading ? "Verifying..." : "Verify"}
                  </button>
                </Form.Item>
              </Form>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Login;
